import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';

import { UserService } from "app/services/user.service";
import { User } from 'app/models/user';
import { DatatableComponent } from "@swimlane/ngx-datatable";
import { map, flatMap, catchError, finalize } from 'rxjs/operators';
import { Team } from 'app/models/team';
import { TeamService } from 'app/services/team.service';
import { Observable, of } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ValidationHandler } from 'app/helpers/validation.handler';
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-teams',
  templateUrl: './teams.component.html',
  styleUrls: ['./teams.component.scss']
})
export class TeamsComponent implements OnInit, AfterViewInit {

  teams:Team[] = [];
  unfilteredTeams:Team[] = [];

  addFormTeamLeaderUsers:User[] = [];
  editFormTeamLeaderUsers:User[] = [];

  users:User[] = [];

  loadingTeamIds:number[] = [];

  tableLoadingIndicator: boolean = true;

  tableLimitSelect: Array<any>;
  selectedTableLimit: number = 5;

  isAddingTeam: boolean = false;
  isEditingTeam: boolean = false;

  editingTeam: Team = null;

  @ViewChild(DatatableComponent, { static: true }) table: DatatableComponent;
  @ViewChild('editModal', { static: true }) editModal: ModalDirective;
  @ViewChild('addModal', { static: true }) addModal: ModalDirective;
  @ViewChild('editSelectedUsers', { static: true }) editSelectedUsers: NgSelectComponent;
  @ViewChild('editSelectedTeamLeader', { static: true }) editSelectedTeamLeader: NgSelectComponent;

  addForm: FormGroup;
  addFormOverlay: FormGroup;
  editForm: FormGroup;

  teamsFilter: string = null;

  constructor(public userService: UserService, private teamService: TeamService, 
    private _validationHandler: ValidationHandler, private formBuilder: FormBuilder, private ecoDocsTitleService: EcoDocsTitleService,
    private activatedRoute: ActivatedRoute) { 

    this.addForm = this.formBuilder.group({
      name: ['', Validators.required],
      user_ids: [[]],
      team_leader_id: [[]],
    });

    this.addFormOverlay = this.formBuilder.group({
      name: ['', Validators.required],
      user_ids: [[]],
      team_leader_id: [[]],
    });

    this.editForm = this.formBuilder.group({
      name: ['', Validators.required],
      user_ids: [[]],
      team_leader_id: [[]],
    });

    this.tableLimitSelect = [5, 10, 20, 30, 50, 100];
    this.selectedTableLimit = 5;

  }

  innerWidth() {
    return window.innerWidth;
  }

  ngOnInit() {
    this.ecoDocsTitleService.setTitle( 'Manage Teams', false );

    this.tableLoadingIndicator = true;
    this.teamService.getAll(true).subscribe(t => {

      this.teams = t; 
      this.unfilteredTeams = [...t];

      setTimeout(() => { this.tableLoadingIndicator = false; }, 100);
      this.updateFilter();
    });

    this.userService.getAll().subscribe(u => { this.users = u; });
  }

  
  ngAfterViewInit(): void {
    this.activatedRoute.queryParams.subscribe((queryParams) => {
      const search: string = queryParams['search']? queryParams['search']: '';
  
      if (search.length > 0) {
        setTimeout(() => {
          this.teamsFilter = search;
          this.updateFilter();            
        }, 1);
      }
    });    
  }

  updateFilter() {
    const val = (this.teamsFilter)? this.teamsFilter.toLowerCase(): null;

    // filter our data
    const temp = this.unfilteredTeams.filter(function(team) {
      return team.name.toLowerCase().indexOf(val) !== -1 || (team.team_leader && team.team_leader.name.toLowerCase().indexOf(val) !== -1) || !val;
    });

    // update the rows
    this.teams = temp;
    
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

  onAddFormSelectedUsersChange(usersSelect: NgSelectComponent, teamLeaderSelect: NgSelectComponent) {
    this.addFormTeamLeaderUsers = [...<User[]>usersSelect.selectedValues];

    if (teamLeaderSelect.selectedValues.length > 0 && !usersSelect.selectedValues.find((v, i) => {return v['email'] == teamLeaderSelect.selectedValues[0]['email']}))
      this.addForm.get('team_leader_id').patchValue([]);

  }

  onEditFormSelectedUsersChange() {
    this.editFormTeamLeaderUsers = [...<User[]>this.editSelectedUsers.selectedValues];

    if (this.editSelectedTeamLeader.selectedValues.length > 0 && !this.editSelectedUsers.selectedValues.find((v, i) => {return v['email'] == this.editSelectedTeamLeader.selectedValues[0]['email']}))
      this.editForm.get('team_leader_id').patchValue([]);
  }

  onAddTeam(frm: FormGroup) {
    this.isAddingTeam = true;
    if(!frm.valid)
    {
      this._validationHandler.onSubmitCheck(frm);
      this.isAddingTeam = false;
      return ;
    }
    this.teamService.add(frm.value).pipe(finalize(()=> {
      this.addModal.hide();
      this.isAddingTeam = false;
    })).subscribe(t => {
      this.unfilteredTeams.unshift(t);
      // re-apply filter
      this.updateFilter();

      // refresh data
      this.teams = [...this.teams];
      frm.reset();
    }, err => {
      /** @todo handle error */
      this._validationHandler.serverValidationHandler(err, frm);
      this.isAddingTeam = false;

    });
  }

  onCloseEdit() {
    this.editModal.hide();
    this.editingTeam = null;
    this.isEditingTeam = false;
  }

  onEditTeam(team: Team) {
    this.editingTeam = team;
    var user_ids = [];
    team.users.forEach(v => {
      user_ids.push(v.id);
    });
    this.editForm.setValue({
      name: team.name,
      user_ids: user_ids,
      team_leader_id: (team.team_leader)? team.team_leader.id: null,
    });

    this.onEditFormSelectedUsersChange();
    this.editForm.get('team_leader_id').patchValue((team.team_leader)? team.team_leader.id: null);

    this.editModal.show();
  }

  onSaveEditTeam() {
    this.isEditingTeam = true;
    if(!this.editForm.valid)
    {
      this._validationHandler.onSubmitCheck(this.editForm);
      this.isEditingTeam = false;
      return ;
    }

    this.editForm.value.id = this.editingTeam.id;
    
    this.teamService.update(this.editForm.value).pipe(finalize(()=>{
      this.isEditingTeam = false;
      this.editingTeam = null;
    })).subscribe(t => {

      // refresh data
      var teamIndex = this.unfilteredTeams.findIndex((v, i, o) => {
        return v.id == t.id;
      });
      
      if (teamIndex != -1)
        this.unfilteredTeams[teamIndex] = t;

      this.updateFilter();
      this.teams = [...this.teams];
      
      this.editModal.hide();
      this.isEditingTeam = false;
      this.editingTeam = null;
      this.editForm.reset();
    }, err => {
      /** @todo handle error */
      this._validationHandler.serverValidationHandler(err, this.editForm);
      this.isEditingTeam = false;

    });
  } 

  onActivateChanged(event, team) {
    if (event.target.checked) {
      if (!this.loadingTeamIds.includes(team.id)) {
        this.teamService.restore(team.id).pipe(map(x => {
          /** @todo handle error */
          team.deleted_at = null;
          this.loadingTeamIds = this.loadingTeamIds.filter(id => id != team.id);
          this.teams = [...this.teams];
        })).subscribe();
        this.loadingTeamIds.push(team.id);
      }
    } else {
      if (!this.loadingTeamIds.includes(team.id)) {
        this.teamService.deactivate(team.id).subscribe(x => {
          /** @todo handle error */
          team.deleted_at = Date.now();
          this.loadingTeamIds = this.loadingTeamIds.filter(id => id != team.id);
          this.teams = [...this.teams];
        });
        this.loadingTeamIds.push(team.id);
      }
    }
  }

}
